export default __webpack_public_path__ + "static/media/treatment-default-picture.007a49f2.jpg";